exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".template-thumbnail[data-v-0f397924]{width:80px;height:50px;margin-left:10px;margin-top:5px;border:1px solid #ddd;border-radius:4px;cursor:pointer;object-fit:cover;transition:all .3s;display:inline-block;vertical-align:middle}.template-thumbnail[data-v-0f397924]:hover{border-color:#409eff;box-shadow:0 2px 8px rgba(64,158,255,.3);transform:scale(1.05)}.el-radio[data-v-0f397924]{display:block;margin-bottom:15px;line-height:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f397924","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/jiaoben/basicConfigure.vue
// module id = 2076
// module chunks = 0